<template>
  <div class="load" :class="isInLiveRoom? 'liveRoomBg' : ''">
    <van-overlay :show="isLoad" z-index="9999">
        <div class="wrapper">
            <van-loading size="80" color="#eb457e" />
        </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "loadCom",
    data() {
        return {
            isLoad: false
        }
    },
    computed: {
        ...mapState(['isLoadForLoad']),
        isInLiveRoom() {
            let flag = false;
            if (this.$route.path == '/liveRoom') {
                flag = true;
            }

            return flag;
        }
    },
    watch: {
        isLoadForLoad(val) {
            this.isLoad = val;
        }
    },
    created() {
        this.isLoad = this.isLoadForLoad;
    }
}
</script>

<style lang="scss">
.load .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.liveRoomBg .van-overlay {
    background-color: #000;
}
</style>